export default rendererMode => {
    return {
        styling: !rendererMode ? { pointerEvents: 'none' } : {}
    }
};